/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Policy_Seo_DescriptionInputs */

const en_cookie_policy_seo_description = /** @type {(inputs: Cookie_Policy_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The cookies this product sets and the choices you have.`)
};

const es_cookie_policy_seo_description = /** @type {(inputs: Cookie_Policy_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las cookies que utiliza este producto y las opciones que tienes.`)
};

const fr_cookie_policy_seo_description = /** @type {(inputs: Cookie_Policy_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les cookies utilisés par ce produit et les choix dont vous disposez.`)
};

/**
* | output |
* | --- |
* | "The cookies this product sets and the choices you have." |
*
* @param {Cookie_Policy_Seo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const cookie_policy_seo_description = /** @type {((inputs?: Cookie_Policy_Seo_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Policy_Seo_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cookie_policy_seo_description(inputs)
	if (locale === "es") return es_cookie_policy_seo_description(inputs)
	return fr_cookie_policy_seo_description(inputs)
});